import { render, staticRenderFns } from "./SipSettings.vue?vue&type=template&id=05c93080&scoped=true&"
import script from "./SipSettings.vue?vue&type=script&lang=js&"
export * from "./SipSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c93080",
  null
  
)

export default component.exports